/** UC-174: format master_products.eve_id for Variants Manager display. */
export function formatEveId(eveId: number): string {
  return `EVE-${eveId}`;
}
